export const FIELD_ERROR = "This field is required"
